import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-units-or-sublots',
  templateUrl: './units-or-sublots.component.html',
  styleUrls: ['./units-or-sublots.component.css']
})
export class UnitsOrSublotsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.UnitsOrSublots.columns;
    this.data = this.report.UnitsOrSublots.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.UnitsOrSublots.data;
    const gridInstance = this.gridContext.getInstance('UnitsOrSublots');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/units-or-sublots/units-or-sublots.component.ts